<template>
  <div class="row justify-content-md-end w-100 ml-0">
    <div class="col-sm-6 col-md-2 mb-2">
      <date-picker-input :placeholder="$t('Create From')" v-model="form.createdFrom"/>
    </div>
    <div class="col-sm-6 col-md-2 mb-2">
      <date-picker-input :placeholder="$t('Create To')" v-model="form.createdTo"/>
    </div>
    <div class="col-sm-6 col-md-2 mb-2">
      <d-select-input
          v-model="form.status"
          :placeholder="$t('Status Filter')"
          class-name="custom-select"
          :options="statusOptions"
      />
    </div>
    <div class="col-sm-6 col-md-4 mb-2 d-f-r">
      <d-text-input
          type="text"
          name="keyword"
          v-model="form.keyword"
          :placeholder="$t('Notification ID, message')"
      />
      <form-button
          @click="$emit('click')"
          type="primary"
          style="width: 80px; height: 36px"
          :disabled="disabled"
          input-type="button"
          class="form-control ml-2"
      >
        <i class="fa fa-search text-white"/>
      </form-button>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/Form/InputText";
import InputSelect from "@/components/Form/InputSelect";
import FormButton from "@/components/Form/FormButton";
import DatePickerInput from "@/components/Common/DatePickerInput";
import DSelectInput from "@/components/input/DSelectInput";
import DTextInput from "@/components/input/DTextInput";

export default {
  name: "NotificationFilter",
  components: {DTextInput, DSelectInput, DatePickerInput, FormButton, InputSelect, InputText},
  props: {
    value: Object,
    disabled: Boolean
  },
  data() {
    return {
      form: this.value
    }
  },
  computed: {
    statusOptions() {
      return [
        {value: 0, text: this.$t('Unread')},
        {value: 1, text: this.$t('Readed')},
      ];
    },
  }
}
</script>